export default {
  title: "趨勢圖表",
  recent_records: "最新記錄",
  preview_report: "預覽報告",
  compliant_status_good: "合規狀態良好",
  custom_factor_status: "使用自訂係數，合規狀態待定",
  tax_amount: "稅費金額",
  based_on_eur: "基於 €{amount}",
  total_emission: "總排放量",
  recent_calculation_date: "最近計算日期",
  no_records: "無記錄",
  calculate_now: "立即計算",
  cbam_news: "CBAM 新聞",
  no_news: "暫無新聞",
  usage_stats_and_price: "使用統計與碳價",
  monthly_calculation_count: "每月計算次數",
  monthly_report_count: "每月報告數量",
  monthly_avg_emission: "每月平均排放量",
  today_carbon_price: "今日碳價",
  current_plan: "目前方案：{plan}",
  upgrade_now: "立即升級",
  trial_remaining: "剩餘 {days} 天，{calculations} 次計算，{reports} 份報告",
  expiry_date: "到期日期：{date}",
  free_plan_desc1: "每月 100 次計算，每天 1 份報告",
  free_plan_desc2: "升級以解鎖更多功能！",
  trial_expired: "試用期已過期，升級到專業方案 (99 歐元/月) 以繼續使用",
  config_fetch_failed: "設定獲取失敗",
};
